import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Tag, Button, Space } from 'antd';
import { ChannelsFilterProvider, useChannelsFilter } from '../contexts/ChannelsFilterContext';
import { ChannelScopeProvider } from '../contexts/ChannelScopeContext';
import { ChannelsDataProvider } from '../contexts/ChannelsDataContext';
import './ChannelsLayout.css';

function shouldHideChannelsChrome(pathname) {
  if (pathname.includes('/activity') || pathname.includes('/connect')) return true;
  if (pathname.startsWith('/channels/widgets/') && pathname.includes('/sessions')) return true;
  if (pathname.startsWith('/channels/shares/')) return true;
  return false;
}

function AssistantFilterBar() {
  const { assistantId, clearAssistantFilter } = useChannelsFilter();
  if (!assistantId) return null;
  return (
    <div className="channels-assistant-filter page-container">
      <Space>
        <Tag color="blue">Assistant filter: #{assistantId}</Tag>
        <Button type="link" size="small" onClick={clearAssistantFilter}>
          View all
        </Button>
      </Space>
    </div>
  );
}

function ChannelsLayoutInner() {
  const { pathname } = useLocation();
  const hideChrome = shouldHideChannelsChrome(pathname);

  if (hideChrome) {
    return (
      <div className="channels-layout-content--full">
        <Outlet />
      </div>
    );
  }

  return (
    <ChannelScopeProvider>
      <ChannelsDataProvider>
        <AssistantFilterBar />
        <Outlet />
      </ChannelsDataProvider>
    </ChannelScopeProvider>
  );
}

export default function ChannelsLayout() {
  return (
    <ChannelsFilterProvider>
      <ChannelsLayoutInner />
    </ChannelsFilterProvider>
  );
}
